<li
  class="root"
  [rkDndDropzone]="['track']"
  (dndDrop)="dropped($event)"
  [dndDisableIf]="isActive"
  data-cy="library-root-trash"
>
  <div class="head">
    <a class="link" [routerLink]="['/radio/' + radioId + '/media/trash']">
      <mat-icon fontSet="fa" [fontIcon]="'fa-trash'" class="trash-icon"></mat-icon>
      <span>{{ 'MEDIA.TRASH.TITLE' | translate }}</span>
    </a>
    <div class="toggle-left">
      <span class="count">{{ archivedTracksLength$ | async }}</span>
    </div>
  </div>
</li>
